import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleReport } from "../../actions/ui_actions";

import {
  CommandBarButton,
  ActionButton,
  DefaultButton
} from "office-ui-fabric-react/lib/Button";
import {
  ContextualMenuItemType,
  ContextualMenuItem
} from "office-ui-fabric-react/lib/ContextualMenu";
import TransitExelExport from "../../views/Reports/_TransitExelExport";
import TruckExelExport from "../../views/Reports/_TruckExelExport";

class ReportToggleButton extends Component {
  state = {
    isTransitExelExportVisible: false,
    isTruckExelExportVisible: false
  };

  render() {
    let { isTransitExelExportVisible, isTruckExelExportVisible } = this.state;

    return (
      <div>
        <CommandBarButton
          styles={{ root: { padding: "10px" } }}
          iconProps={{ iconName: "Documentation" }}
          title="Reports"
          text="Reports"
          menuProps={{
            shouldFocusOnMount: true,
            contextualMenuItemAs: props => <div>{props.item.component}</div>,
            items: [
              {
                key: "manifest",
                component: (
                  <DefaultButton
                    styles={{ root: { padding: "10px" } }}
                    onClick={e => {
                      e.preventDefault();
                      this.props.toggleReport(
                        "manifest",
                        this.props.selectedItems
                      );
                    }}
                    iconProps={{ iconName: "PDF" }}
                    title="Print manifest"
                    text="Manifest"
                  />
                )
              },

              {
                key: "driverReport",
                component: (
                  <DefaultButton
                    styles={{ root: { padding: "10px" } }}
                    onClick={e => {
                      e.preventDefault();
                      this.props.toggleReport(
                        "loadingList",
                        this.props.selectedItems
                      );
                    }}
                    iconProps={{ iconName: "PDF" }}
                    title="Print loading list"
                    text="Loading list"
                  />
                )
              },
              {
                key: "divider_1",
                itemType: ContextualMenuItemType.Divider
              },
              {
                key: "transit_exel",
                component: (
                  <TransitExelExport
                    items={this.props.selectedItems}
                    shipment={this.props.shipment}
                  />
                )
              },
              {
                key: "truck_exel",
                component: (
                  <TruckExelExport
                    items={this.props.items}
                    shipment={this.props.shipment}
                  />
                )
              }
            ]
          }}
        />
        {isTransitExelExportVisible && (
          <TransitExelExport
            items={this.props.selectedItems}
            shipment={this.props.shipment}
          />
        )}
        {isTruckExelExportVisible && (
          <TruckExelExport
            items={this.props.items}
            shipment={this.props.shipment}
          />
        )}
      </div>
    );
  }
}

export default connect(
  null,
  {
    toggleReport: toggleReport
  }
)(ReportToggleButton);



// WEBPACK FOOTER //
// ./src/common/Buttons/_ReportToggleButton.js